<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>我的订单</span></div>
			<div class="center flex-between">
				<centerLeft :menu="6"></centerLeft>
				<div class="center-right">
					<div class="order-status flex-start flex-center">
						<div :class="status === ''?'active':''" @click="changeStatus('')">全部订单</div>
						<div :class="status === 0?'active':''" @click="changeStatus(0)">待付款</div>
						<div :class="status === 1?'active':''" @click="changeStatus(1)">待接单</div>
						<div :class="status === 2?'active':''" @click="changeStatus(2)">待发货</div>
						<div :class="status === 3?'active':''" @click="changeStatus(3)">待收货</div>
						<div :class="status === 4?'active':''" @click="changeStatus(4)">已完成</div>
						<div :class="status === -1?'active':''" @click="changeStatus(-1)">已取消</div>
						<div :class="status === -2?'active':''" @click="changeStatus(-2)">已关闭</div>
					</div>
					
					<div class="order-search">
						<div class="order-search-row flex-between flex-start">
							<div class="order-filters order-filters-keyword flex-start flex-center">
								<div class="order-filter-field flex-start flex-center">
									<div>订单编号</div>
									<el-input v-model="orderNo" clearable placeholder="订单编号" style="width: 140px;"></el-input>
								</div>
								<div class="order-filter-field flex-start flex-center">
									<div>商品编码</div>
									<el-input v-model="goodsNo" clearable placeholder="商品编码" style="width: 140px;"></el-input>
								</div>
								<div class="order-filter-field flex-start flex-center">
									<div>商品名称</div>
									<el-input v-model="goodsName" clearable placeholder="商品名称" style="width: 160px;"></el-input>
								</div>
								<div class="order-filter-field flex-start flex-center">
									<div>收件人</div>
									<el-input v-model="receiveName" clearable placeholder="收件人" style="width: 120px;"></el-input>
								</div>
								<div class="order-filter-field flex-start flex-center">
									<div>收件手机号</div>
									<el-input v-model="phone" clearable placeholder="收件手机号" style="width: 140px;"></el-input>
								</div>
								<div class="order-date flex-start flex-center">
									<div>日期区间</div>
									<el-date-picker v-model="time" type="daterange" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px;"></el-date-picker>
								</div>
								<div class="order-pay-type flex-start flex-center">
									<div>支付方式</div>
									<el-select v-model="payType" placeholder="全部" clearable style="width: 118px;">
										<el-option label="信用付" :value="1"></el-option>
										<el-option label="线下付款" :value="2"></el-option>
									</el-select>
								</div>
								<div class="order-pay-type flex-start flex-center">
									<div>付款凭证</div>
									<el-select v-model="paymentImageStatus" placeholder="全部" clearable style="width: 118px;">
										<el-option label="未上传" :value="1"></el-option>
										<el-option label="已上传" :value="0"></el-option>
									</el-select>
								</div>
								<div v-if="showInvoiceStatusFilter" class="order-pay-type flex-start flex-center">
									<div>是否开票</div>
									<el-select v-model="invoiceStatusFilter" placeholder="全部" clearable style="width: 118px;">
										<el-option label="未开票" :value="1"></el-option>
										<el-option label="已开票" :value="0"></el-option>
									</el-select>
								</div>
								<div class="order-button flex-end flex-center">
									<div @click="getTop">查询</div>
									<div @click="importList">导出</div>
								</div>
							</div>
						</div>
					</div>
					
					<div v-if="total > 0 && payableOnPage.length" class="order-batch-pay-bar flex-between flex-center">
						<el-checkbox
							:indeterminate="paySelectIndeterminate"
							:value="paySelectAllOnPage"
							@change="onToggleSelectAllPayable"
						>全选本页待支付</el-checkbox>
						<div class="batch-pay-actions flex-start flex-center">
							<span v-if="selectedPayOrders.length" class="batch-pay-count">已选 {{ selectedPayOrders.length }} 笔</span>
							<el-button type="primary" size="small" :disabled="!selectedPayOrders.length" @click="toBatchPay">批量支付</el-button>
						</div>
					</div>

					<div v-if="total > 0 && transferUploadableOnPage.length" class="order-batch-pay-bar order-batch-transfer-bar flex-between flex-center">
						<el-checkbox
							:indeterminate="transferSelectIndeterminate"
							:value="transferSelectAllOnPage"
							@change="onToggleSelectAllTransferUploadable"
						>全选本页未上传付款凭证的信用付订单</el-checkbox>
						<div class="batch-pay-actions flex-start flex-center">
							<span v-if="selectedTransferOrders.length" class="batch-pay-count">已选 {{ selectedTransferOrders.length }} 笔</span>
							<el-button type="primary" size="small" :disabled="!selectedTransferOrders.length" @click="openBatchTransferDialog">批量上传付款凭证</el-button>
						</div>
					</div>

					<div v-if="total > 0 && receivableOnPage.length" class="order-batch-pay-bar order-batch-receive-bar flex-between flex-center">
						<el-checkbox
							:indeterminate="receiveSelectIndeterminate"
							:value="receiveSelectAllOnPage"
							@change="onToggleSelectAllReceivable"
						>全选本页待收货</el-checkbox>
						<div class="batch-pay-actions flex-start flex-center">
							<span v-if="selectedReceiveOrders.length" class="batch-pay-count">已选 {{ selectedReceiveOrders.length }} 笔</span>
							<el-button type="success" size="small" :disabled="!selectedReceiveOrders.length" @click="batchConfirmReceive">批量确认收货</el-button>
						</div>
					</div>
					
					<div class="order-list" v-if="total > 0">
						<div class="order-item" v-for="(item, index) in list" :key="item.id">
							<div class="order-top flex-between flex-center">
								<div class="order-top-left flex-start flex-center">
									<el-checkbox
										v-if="isPayableOrder(item)"
										class="order-pay-checkbox"
										:value="isPayOrderSelected(item.id)"
										@change="(v) => onPayOrderCheckChange(item, v)"
									/>
									<el-checkbox
										v-if="isTransferUploadableOrder(item)"
										class="order-pay-checkbox order-transfer-checkbox"
										:value="isTransferOrderSelected(item.id)"
										@change="(v) => onTransferOrderCheckChange(item, v)"
									>凭证</el-checkbox>
									<el-checkbox
									v-if="item.orderStatus == 3"
									class="order-pay-checkbox order-receive-checkbox"
									:value="isReceiveOrderSelected(item.id)"
									@change="(v) => onReceiveOrderCheckChange(item, v)"
								>收货</el-checkbox>
								<div class="order-top-meta">下单时间:{{item.createTime}}<span>订单编号:{{item.orderNo}}</span></div>
								</div>
								<div class="order-top-actions flex-start flex-center">
									<div v-if="isOrderInvoiced(item)" class="order-invoice-btn" @click.stop="previewInvoice(item)">已开发票</div>
									<div class="order-top-button" v-if="item.payType == 1 && !item.transferImage" @click="uploadImage(item.id)">上传付款凭证</div>
									<div class="order-top-button" v-if="item.payType == 1 && item.transferImage" @click="uploadImage(item.id)">已上传</div>
								</div>
							</div>
							
							<div class="order-info flex-between flex-center">
								<div style="width: 100%;">
									<img class="order-info-image" v-for="(value,key) in item.goodsList" v-if="key < 4" :src="value.goodsSpecImage"></img>
								</div>
								<!-- <div class="order-info-name flex-start flex-center" v-if="item.goodsList.length > 1"><span class="one">{{item.goodsList[0].goodsName}}</span>等多个</div> -->
								<!-- <div class="order-info-name" v-else><span class="one">{{item.goodsList[0].goodsName}}</span></div> -->
								<div class="order-info-status" v-if="item.orderStatus == -2">已关闭</div>
								<div class="order-info-status" v-if="item.orderStatus == -1">已取消</div>
								<div class="order-info-status" v-if="item.orderStatus == 0">待支付</div>
								<div class="order-info-status" v-if="item.orderStatus == 1">待接单</div>
								<div class="order-info-status" v-if="item.orderStatus == 2">待发货</div>
								<div class="order-info-status" v-if="item.orderStatus == 3">待签收</div>
								<div class="order-info-status" v-if="item.orderStatus == 4">已完成</div>
								<div class="order-info-price">
									<div>￥{{item.meetPrice}}</div>
									<div>（含运费：￥{{item.freightPrice}}元）</div>
									<div v-if="item.payType == 1">信用付</div>
									<div v-if="item.payType == 2">线下付款</div>
								</div>
								
								<div class="order-info-button">
									<div class="order-info-button-button" v-if="item.orderStatus == 0 && item.payType != 2" @click="toPay(item.id)">去支付</div>
									<div class="order-info-button-button" v-if="item.orderStatus == 0 && item.payType == 2 && item.paymentStatus === -1" @click="toPay(item.id)">去支付</div>
									<div class="order-info-button-button" v-if="item.orderStatus == 3" @click="changeStatusValue(item.id,index, 4)">确认收货</div>
									<div @click="toOrderInfo(item.id)">查看详情</div>
									<div v-if="item.orderStatus != 0" @click="addshop(item.id)">加入购物车</div>
									<div v-if="item.orderStatus == 0" @click="changeStatusValue(item.id,index, -1)">取消订单</div>
									<div v-if="item.orderStatus > 0" @click="toRefund(item.id)">申请售后</div>
								</div>
								
							</div>
							
						</div>
					</div>
					<div class="page" v-if="total > 0">
					    <el-pagination
					        @current-change="getPageList"
					        @size-change="handleSizeChange"
					        :current-page="page"
					        :page-size="limit"
					        :page-sizes="[10, 20, 30]"
					        layout="total, sizes, prev, pager, next"
					        :total="total"></el-pagination>
					</div>
					<noData v-if="list.length == 0 && isLoad == true" msg="暂无订单"></noData>
				</div>
			</div>
		</div>
	  </div>
	  
	  <el-dialog :title="form.isBatch ? '批量上传付款凭证' : '上传付款凭证'" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" @closed="onTransferDialogClosed">
	    
		<div class="pay-four">
			<div v-if="form.isBatch" class="batch-transfer-tip">将为已选 {{ form.ids.length }} 笔信用付订单上传同一组付款凭证图片。</div>
			<div class="image-list flex-start flex-center flex-wrap">
				<div v-for="(item,index) in form.image" :key="index" class="image-list-item">
					<img :src="item"/>
					<img  v-if="form.status" src="@/assets/images/close.png" class="icon-close" @click="form.image.splice(index,1)"/>
				</div>
				<el-upload v-if="form.status"
					:action="$apiBase + '/system/upload'"
					accept="image/*"
					ref="uploadFile"
					multiple
					:limit="transferImageMax"
					:show-file-list="false"
					:on-exceed="onTransferImageExceed"
					:before-upload="beforeTransferUpload"
					:on-success="successImage"
				>
					<div class="image-list-add">
						<img src="@/assets/images/add2.png"/>
						<div>选择图片（可多选）</div>
					</div>
				</el-upload>
			</div>
		</div>
	    <span slot="footer" class="dialog-footer">
	      <el-button @click="dialogVisible = false">取 消</el-button>
	      <el-button type="primary" @click="submitImage" v-if="form.status">确 定</el-button>
	    </span>
	  </el-dialog>

	  <el-dialog title="发票预览" :visible.sync="invoicePreviewVisible" width="880px" top="5vh" append-to-body @closed="invoicePreviewUrl = ''">
	    <iframe v-if="invoicePreviewUrl" :src="invoicePreviewUrl" class="invoice-preview-frame" title="发票 PDF"></iframe>
	    <span slot="footer" class="dialog-footer">
	      <el-button @click="openInvoiceInNewTab">在新窗口打开</el-button>
	      <el-button type="primary" @click="invoicePreviewVisible = false">关 闭</el-button>
	    </span>
	  </el-dialog>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import noData from '@/components/noData.vue'
import {getOrderList,updateOrderStatus,copyOrder,downloadExcel,orderInfo,saveTransferImage,createBatchPay,batchConfirmReceive} from "@/api/user"
import moment from "moment"
export default {
	name: 'index',
	components:{
		centerLeft,
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:10,
			total:0,
			isLoad:false,
			status:"",
			payType: null,
			paymentImageStatus: null,
			invoiceStatusFilter: null,
			invoicePreviewVisible: false,
			invoicePreviewUrl: '',
			orderNo: '',
			goodsNo: '',
			goodsName: '',
			receiveName: '',
			phone: '',
			time:[],
			dialogVisible:false,
			transferImageMax: 9,
			selectedPayOrders: [],
			selectedTransferOrders: [],
			selectedReceiveOrders: [],
			form:{
				id:0,
				ids:[],
				image:[],
				status:false,
				isBatch:false
			}
		}
	},
	computed:{
		showInvoiceStatusFilter(){
			return this.status === '' || this.status === 4;
		},
		payableOnPage(){
			return this.list.filter((item) => this.isPayableOrder(item));
		},
		paySelectAllOnPage(){
			const ids = this.payableOnPage.map((i) => i.id);
			return ids.length > 0 && ids.every((id) => this.isPayOrderSelected(id));
		},
		paySelectIndeterminate(){
			const ids = this.payableOnPage.map((i) => i.id);
			const n = ids.filter((id) => this.isPayOrderSelected(id)).length;
			return n > 0 && n < ids.length;
		},
		transferUploadableOnPage(){
			return this.list.filter((item) => this.isTransferUploadableOrder(item));
		},
		transferSelectAllOnPage(){
			const ids = this.transferUploadableOnPage.map((i) => i.id);
			return ids.length > 0 && ids.every((id) => this.isTransferOrderSelected(id));
		},
		transferSelectIndeterminate(){
			const ids = this.transferUploadableOnPage.map((i) => i.id);
			const n = ids.filter((id) => this.isTransferOrderSelected(id)).length;
			return n > 0 && n < ids.length;
		},
		receivableOnPage(){
			return this.list.filter((item) => item.orderStatus === 3);
		},
		receiveSelectAllOnPage(){
			const ids = this.receivableOnPage.map((i) => i.id);
			return ids.length > 0 && ids.every((id) => this.isReceiveOrderSelected(id));
		},
		receiveSelectIndeterminate(){
			const ids = this.receivableOnPage.map((i) => i.id);
			const n = ids.filter((id) => this.isReceiveOrderSelected(id)).length;
			return n > 0 && n < ids.length;
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		isPayableOrder(item){
			if (item.orderStatus !== 0) {
				return false;
			}
			if (item.payType != 2) {
				return true;
			}
			return item.paymentStatus === -1;
		},
		isTransferUploadableOrder(item){
			return item && item.payType == 1 && !item.transferImage;
		},
		isPayOrderSelected(id){
			return this.selectedPayOrders.some((x) => x.id === id);
		},
		isTransferOrderSelected(id){
			return this.selectedTransferOrders.some((x) => x.id === id);
		},
		onPayOrderCheckChange(item, checked){
			if (checked) {
				if (!this.isPayOrderSelected(item.id)) {
					this.selectedPayOrders.push({
						id: item.id,
						payType: item.payType
					});
				}
			} else {
				this.selectedPayOrders = this.selectedPayOrders.filter((x) => x.id !== item.id);
			}
		},
		onToggleSelectAllPayable(checked){
			const ids = this.payableOnPage.map((i) => i.id);
			if (checked) {
				const map = new Map(this.selectedPayOrders.map((x) => [x.id, x]));
				this.payableOnPage.forEach((item) => {
					map.set(item.id, { id: item.id, payType: item.payType });
				});
				this.selectedPayOrders = Array.from(map.values());
			} else {
				const drop = new Set(ids);
				this.selectedPayOrders = this.selectedPayOrders.filter((x) => !drop.has(x.id));
			}
		},
		onTransferOrderCheckChange(item, checked){
			if (checked) {
				if (!this.isTransferOrderSelected(item.id)) {
					this.selectedTransferOrders.push({ id: item.id });
				}
			} else {
				this.selectedTransferOrders = this.selectedTransferOrders.filter((x) => x.id !== item.id);
			}
		},
		onToggleSelectAllTransferUploadable(checked){
			const ids = this.transferUploadableOnPage.map((i) => i.id);
			if (checked) {
				const map = new Map(this.selectedTransferOrders.map((x) => [x.id, x]));
				this.transferUploadableOnPage.forEach((item) => {
					map.set(item.id, { id: item.id });
				});
				this.selectedTransferOrders = Array.from(map.values());
			} else {
				const drop = new Set(ids);
				this.selectedTransferOrders = this.selectedTransferOrders.filter((x) => !drop.has(x.id));
			}
		},
		isReceiveOrderSelected(id){
			return this.selectedReceiveOrders.some((x) => x.id === id);
		},
		onReceiveOrderCheckChange(item, checked){
			if (checked) {
				if (!this.isReceiveOrderSelected(item.id)) {
					this.selectedReceiveOrders.push({ id: item.id });
				}
			} else {
				this.selectedReceiveOrders = this.selectedReceiveOrders.filter((x) => x.id !== item.id);
			}
		},
		onToggleSelectAllReceivable(checked){
			const ids = this.receivableOnPage.map((i) => i.id);
			if (checked) {
				const map = new Map(this.selectedReceiveOrders.map((x) => [x.id, x]));
				this.receivableOnPage.forEach((item) => {
					map.set(item.id, { id: item.id });
				});
				this.selectedReceiveOrders = Array.from(map.values());
			} else {
				const drop = new Set(ids);
				this.selectedReceiveOrders = this.selectedReceiveOrders.filter((x) => !drop.has(x.id));
			}
		},
		batchConfirmReceive(){
			if (!this.selectedReceiveOrders.length) {
				return this.$message.warning('请选择待收货订单');
			}
			this.$alert('确定对已选 ' + this.selectedReceiveOrders.length + ' 笔订单确认收货吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton: true,
				callback: action => {
					if (action === 'confirm') {
						const ids = this.selectedReceiveOrders.map((x) => x.id);
						batchConfirmReceive({ ids: ids }).then(res => {
							if (res.code == 1000) {
								this.$message.success('批量确认收货成功');
								this.selectedReceiveOrders = [];
								this.getList();
							} else {
								this.$message.error(res.message || '操作失败');
							}
						}).catch(() => {
							this.$message.error('请求失败');
						});
					}
				}
			});
		},
		toBatchPay(){
			if (!this.selectedPayOrders.length) {
				return this.$message.warning('请选择待支付订单');
			}
			const types = [...new Set(this.selectedPayOrders.map((x) => x.payType))];
			if (types.length > 1) {
				return this.$message.warning('批量支付仅支持相同支付方式的订单，请重新选择');
			}
			const ids = this.selectedPayOrders.map((x) => x.id);
			createBatchPay(ids).then((res) => {
				if (res.code == 1000) {
					this.$router.push('/batchpay?id=' + res.data);
				} else {
					return this.$message.error(res.message);
				}
			});
		},
		syncSelectedPayOrdersWithList(){
			this.selectedPayOrders = this.selectedPayOrders.filter((sel) => {
				const row = this.list.find((item) => item.id === sel.id);
				if (!row) {
					return true;
				}
				return this.isPayableOrder(row);
			});
		},
		syncSelectedTransferOrdersWithList(){
			this.selectedTransferOrders = this.selectedTransferOrders.filter((sel) => {
				const row = this.list.find((item) => item.id === sel.id);
				if (!row) {
					return true;
				}
				return this.isTransferUploadableOrder(row);
			});
		},
		isOrderInvoiced(item){
			return String(item.invoiceStatus) === '0';
		},
		previewInvoice(item){
			if (!item.invoiceFile) {
				return this.$message.warning('暂无发票文件');
			}
			this.invoicePreviewUrl = item.invoiceFile;
			this.invoicePreviewVisible = true;
		},
		openInvoiceInNewTab(){
			if (this.invoicePreviewUrl) {
				window.open(this.invoicePreviewUrl, '_blank');
			}
		},
		mergeKeywordSearchParams(obj){
			const keys = ['orderNo','goodsNo','goodsName','receiveName','phone'];
			keys.forEach((k) => {
				const v = this[k];
				if (v != null && String(v).trim() !== '') {
					obj[k] = String(v).trim();
				}
			});
		},
		getList(){
			const condition = {
				orderStatus:this.status,
				startTime:((this.time != null && this.time.length==2)?moment(this.time[0]).format('yyyy-MM-DD'):''),
				endTime:((this.time != null && this.time.length==2)?moment(this.time[1]).format('yyyy-MM-DD'):'')
			};
			if (this.payType === 1 || this.payType === 2) {
				condition.payType = this.payType;
			}
			if (this.paymentImageStatus === 0 || this.paymentImageStatus === 1) {
				condition.paymentImageStatus = this.paymentImageStatus;
			}
			if (this.showInvoiceStatusFilter && (this.invoiceStatusFilter === 0 || this.invoiceStatusFilter === 1)) {
				condition.invoiceStatus = this.invoiceStatusFilter;
			}
			this.mergeKeywordSearchParams(condition);
			getOrderList({condition,page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					res.data.list.map((item,index)=>{
						orderInfo({orderId:item.id}).then(res=>{
							if(res.code == 1000){
								this.list[index].transferImage = res.data.transferImage;
								this.$forceUpdate();
							}
						})
					})
					this.isLoad = true;
					this.$nextTick(() => {
						this.syncSelectedPayOrdersWithList();
						this.syncSelectedTransferOrdersWithList();
					});
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		successImage(e){
			if(e.code == 1000){
				this.form.image.push(e.data);
			}
		},
		onTransferImageExceed(){
			this.$message.warning('最多上传 ' + this.transferImageMax + ' 张图片');
		},
		beforeTransferUpload(){
			if (this.form.image.length >= this.transferImageMax) {
				this.$message.warning('最多上传 ' + this.transferImageMax + ' 张图片');
				return false;
			}
			return true;
		},
		onTransferDialogClosed(){
			const ref = this.$refs.uploadFile;
			if (ref && typeof ref.clearFiles === 'function') {
				ref.clearFiles();
			}
		},
		//上传付款照片
		uploadImage(id){
			orderInfo({orderId:id}).then(res=>{
				if(res.code == 1000){
					this.form = {
						id:res.data.id,
						ids:[res.data.id],
						image:res.data.transferImage?res.data.transferImage.split(","):[],
						status:res.data.transferImage?false:true,
						isBatch:false
					};
					this.dialogVisible = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		openBatchTransferDialog(){
			if (!this.selectedTransferOrders.length) {
				return this.$message.warning('请选择未上传付款凭证的信用付订单');
			}
			this.form = {
				id:0,
				ids:this.selectedTransferOrders.map((x) => x.id),
				image:[],
				status:true,
				isBatch:true
			};
			this.dialogVisible = true;
		},
		//提交图片日志
		submitImage(){
			if(this.form.image.length == 0){
				return this.$message.error("请上传图片");
			}
			if (this.form.isBatch) {
				return this.submitBatchTransferImage();
			}
			saveTransferImage({
				orderId:this.form.id,
				transferImage:this.form.image.join(",")
			}).then(res=>{
				if(res.code == 1000){
					this.dialogVisible = false;
					this.$message.success("操作完成");
					this.getList();
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		submitBatchTransferImage(){
			const image = this.form.image.join(",");
			const ids = this.form.ids.slice();
			const failed = [];
			const run = async () => {
				for (const orderId of ids) {
					const res = await saveTransferImage({
						orderId,
						transferImage:image
					});
					if (res.code != 1000) {
						failed.push(orderId);
					}
				}
			};
			run().then(() => {
				if (failed.length) {
					this.$message.error('部分订单上传失败：' + failed.join(','));
				} else {
					this.dialogVisible = false;
					this.selectedTransferOrders = [];
					this.$message.success('批量上传付款凭证完成');
				}
				this.getList();
			}).catch((e) => {
				this.$message.error(e && e.message ? e.message : '批量上传失败');
			});
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		//切换每页条数（10/20/30）
		handleSizeChange(size){
			this.limit = size;
			this.page = 1;
			this.getList();
		},
		changeStatus(status){
			this.status = status;
			if (status !== '' && status !== 4) {
				this.invoiceStatusFilter = null;
			}
			this.getTop();
		},
		getTop(){
			this.isLoad = false;
			this.page = 1;
			this.getList();
		},
		toPay(id){
			this.$router.push("/pay?id="+(id*23+20));
		},
		toOrderInfo(id){
			this.$router.push("/orderinfo?id="+(id*23+20));
		},
		changeStatusValue(id,index, status){
			this.$alert('确定操作吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						updateOrderStatus({orderId:id,orderStatus:status}).then(res=>{
							if(res.code == 1000){
								this.getList();
								this.$message.success("操作完成");
							}else{
								return this.$message.error(res.message);
							}
						})
					}
				}
			});
		},
		addshop(id){
			this.$alert('确定要加入购物车吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						copyOrder({id:id}).then(res=>{
							if(res.code == 1000){
								this.$message.success("操作完成");
							}else{
								this.$message.error(res.message);
							}
						})
					}
				}
			});
		},
		toRefund(id){
			this.$router.push("/userrefund?id="+id);
		},
		//导出订单
		importList(){
			const params = {
				orderStatus:this.status,
				startTime:((this.time != null && this.time.length==2)?moment(this.time[0]).format('yyyy-MM-DD'):''),
				endTime:((this.time != null && this.time.length==2)?moment(this.time[1]).format('yyyy-MM-DD'):'')
			};
			if (this.payType === 1 || this.payType === 2) {
				params.payType = this.payType;
			}
			if (this.paymentImageStatus === 0 || this.paymentImageStatus === 1) {
				params.paymentImageStatus = this.paymentImageStatus;
			}
			if (this.showInvoiceStatusFilter && (this.invoiceStatusFilter === 0 || this.invoiceStatusFilter === 1)) {
				params.invoiceStatus = this.invoiceStatusFilter;
			}
			this.mergeKeywordSearchParams(params);
			downloadExcel(params).then(response=>{
				var export_blob = new Blob([response]);
				const downloadElement = document.createElement('a');
				const href = window.URL.createObjectURL(export_blob);
				downloadElement.href = href;
				downloadElement.download = `订单列表.xlsx`;
				document.body.appendChild(downloadElement);
				downloadElement.click();
				document.body.removeChild(downloadElement);
				window.URL.revokeObjectURL(href);
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.order-batch-pay-bar{
		width: 960px;
		box-sizing: border-box;
		padding: 12px 16px;
		margin-top: 16px;
		background: rgba(233, 26, 18, 0.04);
		border: 1px solid rgba(7, 11, 19, 0.08);
		border-radius: 4px;
		.batch-pay-actions{
			gap: 16px;
			align-items: center;
		}
		.batch-pay-count{
			font-size: 14px;
			color: rgba(7, 11, 19, 0.65);
		}
	}
	.order-batch-transfer-bar{
		background: rgba(64, 158, 255, 0.06);
	}
	.order-batch-receive-bar{
		background: rgba(103, 194, 58, 0.06);
	}
	.batch-transfer-tip{
		font-size: 14px;
		line-height: 22px;
		color: rgba(7, 11, 19, 0.65);
		margin-bottom: 16px;
	}
	.order-top-left{
		flex: 1;
		min-width: 0;
		align-items: center;
		gap: 12px;
	}
	.order-pay-checkbox{
		flex-shrink: 0;
	}
	.order-top-meta{
		flex: 1;
		min-width: 0;
		padding-right: 16px;
	}
	.order-top-actions{
		flex-shrink: 0;
		gap: 10px;
	}
	.order-invoice-btn{
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 88px;
		height: 30px;
		padding: 0 14px;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 1;
		color: #E91A12;
		background: rgba(233, 26, 18, 0.06);
		border: 1px solid rgba(233, 26, 18, 0.35);
		border-radius: 4px;
		cursor: pointer;
		transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
		user-select: none;
		&:hover{
			background: rgba(233, 26, 18, 0.1);
			border-color: rgba(233, 26, 18, 0.55);
		}
		&:active{
			background: rgba(233, 26, 18, 0.14);
		}
	}
	.invoice-preview-frame{
		width: 100%;
		height: 72vh;
		border: 0;
	}
	.pay-four{
		font-size: 20px;
		color: #9C9DA1;
		span{
			color: #E91A12;
		}
	}
	.image-list{
		.image-list-add{
			width: 106px;
			height: 106px;
			border: 1px dashed rgba(0, 0, 0, 0.4);
			padding: 30px 0px 30px;
			box-sizing: border-box;
			text-align: center;
			margin: 0px 16px 16px 0px;
			img{
				width: 24px;
				height: 24px;
			}
			div{
				font-size: 12px;
				line-height: 16px;
				color: #070B13;
				margin-top: 8px;
			}
		}
		.image-list-item{
			width: 108px;
			height: 108px;
			position: relative;
			margin: 0px 16px 16px 0px;
			img{
				width: 108px;
				height: 108px;
				object-fit: cover;
			}
			.icon-close{
				width: 16px;
				height: 16px;
				position: absolute;
				top: 0px;
				right: 0px;
				cursor: pointer;
			}
		}
	}
	.order-item{
		width: 960px;
		border: 1px solid rgba(7, 11, 19, 0.1);
		box-sizing: border-box;
		margin-top: 20px;
		.order-info{
			padding: 10px 0px 10px 20px;
			box-sizing: border-box;
			width: 100%;
			.order-info-image{
				width: 80px;
				height: 80px;
				border: 1px solid rgba(0, 0, 0, 0.1);
				flex: 0 0 82px;
				margin-right: 20px;
			}
			.order-info-name{
				font-size: 16px;
				color: #070B13;
				width: 100%;
				line-height: 40px;
				span{
					max-width: 300px;
					display: inline-block;
				}
			}
			.order-info-status{
				font-size: 16px;
				color: #070B13;
				flex: 0 0 100px;
				text-align: center;
			}
			.order-info-price{
				font-size: 14px;
				line-height: 22px;
				color: #070B13;
				text-align: center; 
				flex: 0 0 200px;
			}
			.order-info-button{
				border-left: 1px solid rgba(7, 11, 19, 0.1);
				width: 148px;
				text-align: center;
				flex: 0 0 148px;
				div{
					font-size: 12px;
					line-height: 16px;
					color: #070B13;
					margin-bottom: 8px;
					cursor: pointer;
	
				}
				.order-info-button-button{
					width: 88px;
					height: 28px;
					border: 1px solid rgba(233, 26, 18, 0.3);
					font-size: 14px;
					line-height: 28px;
					color: #E91A12;
					text-align: center;
					margin: 0 auto 8px;
				}
			}
		}
		.order-top{
			width: 100%;
			height: 46px;
			background: rgba(233, 26, 18, 0.04);
			font-size: 16px;
			color: #070B13;
			line-height: 46px;
			padding: 0 20px;
			box-sizing: border-box;
			span{
				margin-left: 40px;
			}
			.order-top-actions{
				.order-top-button{
					margin-right: 0;
				}
			}
			.order-top-button{
				width: 110px;
				height: 30px;
				border: 1px solid rgba(233, 26, 18, 0.3);
				font-size: 14px;
				line-height: 30px;
				text-align: center;
				color: #070B13;
				cursor: pointer;
				margin-right: 20px;
				border-radius: 4px;
			}
		}
	}
	.order-list{
		min-height: 680px;
	}
	.order-search{
		margin-top: 18px;
		margin-bottom: 20px;
		min-width: 0;
		.order-search-row{
			gap: 12px 16px;
			flex-wrap: wrap;
			align-items: flex-start;
			min-width: 0;
			margin-bottom: 12px;
		}
		.order-search-row-secondary{
			margin-bottom: 0;
		}
		.order-filters{
			flex-wrap: wrap;
			flex: 1 1 auto;
			min-width: 0;
			align-items: center;
			gap: 10px 12px;
		}
		.order-filters-keyword{
			flex: 1 1 auto;
			min-width: 0;
			padding-right: 8px;
			box-sizing: border-box;
		}
		.order-filter-field{
			flex-shrink: 0;
			div:first-child{
				font-size: 16px;
				line-height: 22px;
				color: #9E9E9E;
				margin-right: 10px;
				white-space: nowrap;
			}
		}
		.order-date{
			flex-shrink: 0;
			div{
				 font-size: 16px;
				 line-height: 22px;
				 color: #9E9E9E;
				 margin-right: 10px;
				 white-space: nowrap;
			}
		}
		.order-pay-type{
			flex-shrink: 0;
			div:first-child{
				font-size: 16px;
				line-height: 22px;
				color: #9E9E9E;
				margin-right: 10px;
				white-space: nowrap;
			}
		}
		.order-button{
			flex-shrink: 0;
			align-self: flex-start;
			div{
				width: 60px;
				height: 44px;
				border: 1px solid rgba(233, 26, 18, 0.3);
				font-size: 14px;
				line-height: 44px;
				text-align: center;
				color: #070B13;
				margin-left: 16px;
				cursor: pointer;
			}
		}
	}
	.order-status{
		div{
			padding: 20px 0px 6px;
			font-size: 16px;
			line-height: 20px;
			color: #070B13;
			border-bottom: 3px solid #fff;
			margin-right: 60px;
			cursor: pointer;
		}
		.active{
			color: #E91A12;
			border-bottom: 3px solid #E91A12;
		}
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
